import { render, staticRenderFns } from "./LargeImage.vue?vue&type=template&id=f4e1980c&scoped=true&"
import script from "./LargeImage.vue?vue&type=script&lang=js&"
export * from "./LargeImage.vue?vue&type=script&lang=js&"
import style0 from "./LargeImage.vue?vue&type=style&index=0&id=f4e1980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e1980c",
  null
  
)

export default component.exports